import { render, staticRenderFns } from "./ServicePages.vue?vue&type=template&id=301afb52&scoped=true&"
import script from "./ServicePages.vue?vue&type=script&lang=ts&"
export * from "./ServicePages.vue?vue&type=script&lang=ts&"
import style0 from "./ServicePages.vue?vue&type=style&index=0&id=301afb52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "301afb52",
  null
  
)

export default component.exports